import { Field, FieldProps } from 'formik';
import React, { ReactNode } from 'react';
import { FormattedMessage, InjectedIntl, injectIntl } from 'react-intl';
import styled from 'styled-components';
import Checkbox from '../components/Checkbox';
import { COLORS } from '../constants/styles';
import Label from './Label';

interface IRadioButtonNormalProps {
    id: string;
    disabled?: boolean;
    label: FormattedMessage.MessageDescriptor | string;
    intl: InjectedIntl;
    value?: boolean;
    required?: boolean;
    tooltipText?: FormattedMessage.MessageDescriptor | string;
    onCheck: () => void;
    qaId?: string;
}

interface IRadioButtonNormalState {
    checked: boolean;
}

const RadioButtonNormalWrapper = styled.label`
    color: ${(props: { checked: boolean }) => (props.checked ? COLORS.rakutenRed : COLORS.grey7)};
    font-size: 0.875rem;
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 100%;
    height: auto;
    & input {
        visibility: hidden;
    }
    & span {
        display: block;
        text-align: left;
        border: 1px solid white;
    }
`;
const RadioBoxWrapper = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    width: 32px;
    height: 32px;
    position: relative;
    color: ${(props: { checked: boolean }) => (props.checked ? COLORS.rakutenRed : COLORS.grey7)};
    border: none;
    background: none;
    padding: 0;

    & .radioBox:after {
        content: '';
        background: ${(props: { checked: boolean }) =>
            props.checked ? COLORS.rakutenRed : 'transparent'};
        position: absolute;
        border-radius: 50%;
        bottom: 0;
        left: 0;
        margin: auto;
        right: 0;
        top: 0;
        height: 10px;
        width: 10px;
    }
`;
const RadioBox = styled.div`
    display: block;
    background-color: ${(props: { checked: boolean }) =>
        props.checked ? COLORS.white : 'transparent'};
    border: solid 2px
        ${(props: { checked: boolean }) => (props.checked ? COLORS.rakutenRed : COLORS.grey)};
    border-radius: 12px;
    height: 24px;
    width: 24px;
    margin: auto;
    opacity: 1;
`;

class RadioButtonNormal extends React.Component<IRadioButtonNormalProps, IRadioButtonNormalState> {
    private readonly ID: string;

    constructor(props: IRadioButtonNormalProps) {
        super(props);
        const { id, value } = this.props;

        this.state = {
            checked: Boolean(value),
        };
        this.ID = id;
        this.onClick = this.onClick.bind(this);
    }

    public render() {
        const { disabled, label, intl, value, qaId } = this.props;
        const labelMessage = typeof label === 'string' ? label : intl.formatMessage(label);
        const checked = Boolean(value);

        return (
            <RadioButtonNormalWrapper
                checked={checked}
                onClick={this.onClick}
                data-qa-id={`${qaId}-radio-button`}
            >
                <input id={this.ID} type="radio" checked={checked} name="radio" readOnly={true} />
                <RadioBoxWrapper
                    checked={checked}
                    className="wrapper"
                    tabIndex={0}
                    aria-labelledby={this.ID + '-label'}
                >
                    <RadioBox checked={checked} className="radioBox" />
                </RadioBoxWrapper>
                <label id={this.ID + '-label'}>{labelMessage}</label>
            </RadioButtonNormalWrapper>
        );
    }

    private onClick() {
        const { value, onCheck } = this.props;
        const { checked } = this.state;
        onCheck();
    }
}

export default injectIntl(RadioButtonNormal);
